import styled from 'styled-components';
import tw from 'twin.macro';

export const ToasterContainer = styled.div`
  ${tw`max-w-md w-full bg-red-50 shadow-lg rounded-lg pointer-events-auto flex px-6 py-4 mb-8`}
  box-shadow:0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 20px 25px -5px rgba(0, 0, 0, 0.1);
`;
export const IconWrapper = styled.div`
  ${tw`flex-shrink-0 pt-0.5`}
`;
export const IconAndToastMessageWrapper = styled.div`
  ${tw`flex items-start`}
`;

export const ToastMessageWrapper = styled.div`
  ${tw`ml-3 flex-1 text-base font-medium text-red-800`}
`;

export const ParagraphElement = styled.p``;

export const ToastWrapper = styled.div`
  ${tw`flex-1 w-0`}
`;

export const CopiedText = styled.div`
  ${tw`font-inter text-sm font-medium text-lightBlueGray px-4 py-1 rounded-4px bg-catskillWhite`}
`;
